import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import IconSvg from "../../../../SharedComponents/IconSvg";
import TestPdfButton from "../../../../PdfDownloadButton/Components/TestPdfButton";
import InventoryPdfButton from "../../../../PdfDownloadButton/Components/InventoryPdfButton";
import { SetSelectedResult } from "../../Store";
import { applicationTypeEnum } from "../../../../../Helpers/EnumHelper";
import { useTranslation } from "react-i18next";

const AssignedAssessmentsListRowButtons = ({ type, result, color, size, applicationName }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const candidate = useSelector((state) => state.candidate.candidate);

  const [isWarningsPresent, setIsWarningsPresent] = useState(false);

  useEffect(() => {
    const hasWarnings = result?.sessions?.some((session) => session.warningFlags && session.warningFlags.length > 0);
    setIsWarningsPresent(hasWarnings);
  }, [result]);

  const HandleWrapUpButton = () => {
    const navigationState = {
      state: {
        candidateId: candidate?.candidateId,
        backUrl: "/candidate/",
      },
    };

    switch (type) {
      case applicationTypeEnum.Inventory:
        navigate("/iwrapup/" + result.resultId, navigationState);
        break;
      case applicationTypeEnum.Test:
        navigate("/twrapup/" + result.resultId, navigationState);
        break;
      case applicationTypeEnum.Survey:
        break;
      default:
        console.warn("Unknown type in HandleWrapUpButton");
    }
  };

  const HandleSelectPdfButton = () => {
    switch (type) {
      case applicationTypeEnum.Inventory:
        return (
          <InventoryPdfButton
            inventoryResultId={result.resultId}
            uiType="assignedAssessmentPdfButton"
            docTitle={candidate?.name + " " + applicationName ?? "unknown_pdf_name"}
          />
        );
      case applicationTypeEnum.Test:
        return (
          <TestPdfButton
            testResultId={result.resultId}
            uiType="assignedAssessmentPdfButton"
            docTitle={candidate?.name + " " + applicationName ?? "unknown_pdf_name"}
          />
        );
      case applicationTypeEnum.Survey:
        return null;
      default:
        console.warn("Unknown type in HandleSelectPdfButton");
        return null;
    }
  };

  return (
    <Row className="justify-content-center">
      <Col xs="auto">
        <Button
          onClick={() => dispatch(SetSelectedResult(result))}
          className="button secondary p-0 position-relative"
          style={{ height: size, width: size, borderRadius: "10px", borderColor: color }}
          title={t("viewDetailsButtonLabel")}
        >
          {isWarningsPresent && (
            <div className="position-absolute flex-center" style={{ height: "20px", top: "-30%", right: "-30%" }}>
              <IconSvg icon="warning-box" width={20} height={20} />
            </div>
          )}
          <IconSvg icon="clock" fill={color} />
        </Button>
      </Col>

      <Col xs="auto">
        <Button
          onClick={HandleWrapUpButton}
          className="button secondary p-0"
          style={{ height: size, width: size, borderRadius: "10px", borderColor: color }}
          title={t("wrapUpButtonLabel")}
        >
          <IconSvg icon="eye" fill={color} />
        </Button>
      </Col>

      <Col xs="auto" title={t("downloadPdfButtonLabel")}>
        {HandleSelectPdfButton()}
      </Col>
    </Row>
  );
};

export default AssignedAssessmentsListRowButtons;
